import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'open-card',
  templateUrl: './open-card.component.html',
  styleUrls: ['./open-card.component.scss']
})
export class OpenCardComponent implements OnInit {
  @Input() componentDetails: any;

  textPadded:string = '';

  ngOnInit(): void {
    this.textPadded = this.componentDetails?.settings?.class.includes('text-padded') ? 'padding-medium' : '';
  }
}



